import React, { useState, useEffect, useCallback } from "react";
import { PostMemberAttestation } from "../../api/memberAttestation/list";
import {
  Card,
  Input,
  Select,
  Button,
  DatePicker,
  Table,
  Pagination,
  Spin,
  Empty,
  ConfigProvider,
} from "antd";
import styles from "./CertificationList.module.scss";
import { SearchOutlined } from "@ant-design/icons";
import { CloseCircleFilled } from "@ant-design/icons";
import zhCN from "antd/es/locale/zh_CN";
import "dayjs/locale/zh-cn";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import clsx from "clsx";
import iconBack from "../../static/home/icon_back.png";
import { useNavigate } from "react-router-dom";
const CertificationList = ({}) => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const { RangePicker } = DatePicker;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [attestationNumber, setAttestationNumber] = useState("");
  const [attestationName, setAttestationName] = useState("");
  const [venueName, setVenueName] = useState("");
  const [venueLevel, setVenueLevel] = useState("");
  const [memberName, setMemberName] = useState("");
  const [status, setStatus] = useState("");
  const [dateRange, setDateRange] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [isOnShow, setIsOnShow] = useState(false);
  const [isPDF, setIsPDF] = useState(false);
  const [imageAddress, setImageAddress] = useState("");
  const [attestationType, setAttestationType] = useState(1);
  const [attestationModel, setAttestationModel] = useState("");
  const [certificationBasis, setCertificationBasis] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [typePage, setTypePage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(10); // 默认每页条数
  const [columns, setColumns] = useState([
    {
      title: (
        <span style={{ color: "#666666" }} className={styles.columnsfontsize}>
          序号
        </span>
      ),
      dataIndex: "key",
      render: (text, record, index) => (
        <span className={styles.columnsfontsize}>{index + 1}</span>
      ),
      width: 60,
    },
    {
      title: (
        <span style={{ color: "#666666" }} className={styles.columnsfontsize}>
          获证组织名称
        </span>
      ),
      dataIndex: "memberName",
      render: (text, record, index) => (
        <span className={styles.columnsfontsize}>{index + 1}</span>
      ),
      flex: 1,
    },
    {
      title: (
        <span style={{ color: "#666666" }} className={styles.columnsfontsize}>
          证书编号
        </span>
      ),
      dataIndex: "attestationNumber",
      render: (text, record, index) => (
        <span className={styles.columnsfontsize}>{index + 1}</span>
      ),
      flex: 1,
    },
    {
      title: (
        <span style={{ color: "#666666" }} className={styles.columnsfontsize}>
          产品名称
        </span>
      ),
      dataIndex: "attestationName",
      render: (text, record, index) => (
        <span className={styles.columnsfontsize}>{index + 1}</span>
      ),
      flex: 1,
    },
    {
      title: (
        <span style={{ color: "#666666" }} className={styles.columnsfontsize}>
          产品型号
        </span>
      ),
      dataIndex: "attestationModel",
      render: (text, record, index) => (
        <span className={styles.columnsfontsize}>{index + 1}</span>
      ),
      flex: 1,
    },
    {
      title: (
        <span style={{ color: "#666666" }} className={styles.columnsfontsize}>
          认证依据
        </span>
      ),
      dataIndex: "certificationBasis",
      render: (text, record, index) => (
        <span className={styles.columnsfontsize}>{index + 1}</span>
      ),
      flex: 1,
    },
    {
      title: (
        <span style={{ color: "#666666" }} className={styles.columnsfontsize}>
          生产地址
        </span>
      ),
      dataIndex: "productionAddress",
      render: (text, record, index) => (
        <span className={styles.columnsfontsize}>{index + 1}</span>
      ),
      flex: 1,
    },
    {
      title: (
        <span style={{ color: "#666666" }} className={styles.columnsfontsize}>
          发证日期
        </span>
      ),
      dataIndex: "issueDate",
      render: (text, record, index) => (
        <span className={styles.columnsfontsize}>{index + 1}</span>
      ),
      flex: 1,
    },
    {
      title: (
        <span style={{ color: "#666666" }} className={styles.columnsfontsize}>
          状态
        </span>
      ),
      dataIndex: "status",
      render: (text, record, index) => (
        <span className={styles.columnsfontsize}>{index + 1}</span>
      ),
      flex: 1,
    },
    {
      title: (
        <span style={{ color: "#666666", paddingRight: "20px" }}>证书详情</span>
      ),
      dataIndex: "certificateDetails",
      align: "right",
      width: 100,
      render: (text, record) => (
        <Button
          type="link"
          onClick={() => openRenders(record)}
          className={styles.columnsfontBtn}
          style={{ background: "#E78110", color: "#fff", fontSize: "14px" }}
        >
          点击查看
        </Button>
      ),
      fixed: "right",
    },
  ]);

  const navList = [
    { value: 1, name: "产品认证证书查询" },
    { value: 2, name: "服务认证证书查询" },
    { value: 3, name: "评估评价证书查询" },
  ];
  const NavItem = ({ name, active, onClick }) => (
    <div
      className={clsx(styles.navItem, { [styles.active]: active })}
      onClick={onClick}
    >
      {name}
      {active && <div className={styles.underline}></div>}
    </div>
  );

  const renderInput = (label, placeholder, value, onChange, key) => (
    <div className={`${styles.item}`}>
      <div className={styles.seachScreenName}>{label}</div>
      <Input
        className={styles.customInput}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value, key)}
      />
    </div>
  );

  const renderSelect = (label, value, onChange, key, options) => (
    <div className={styles.item}>
      <div className={styles.seachScreenName}>{label}</div>
      <Select
        showSearch
        className={styles.customSelect}
        placeholder="请选择"
        optionFilterProp="label"
        value={value}
        onChange={(value) => onChange(value, key)}
        options={options}
      />
    </div>
  );
  const venueLevelList = [
    { value: "", label: "全部" },
    { value: 1, label: "一星级篮球场地" },
    { value: 2, label: "二星级篮球场地" },
    { value: 3, label: "三星级篮球场地" },
    { value: 4, label: "三星级PRO篮球场地" },
  ];
  const statusList = [
    { value: String(-1), label: "全部" },
    { value: String(0), label: "有效" },
    { value: String(1), label: "暂停" },
    { value: String(2), label: "撤销" },
    { value: String(3), label: "注销" },
  ];
  const handleDateRangeChange = (value) => {
    setDateRange(value);
  };
  const handleInputChange = (value, key) => {
    if (key === "attestationModel") {
      setAttestationModel(value);
    }
    if (key === "certificationBasis") {
      setCertificationBasis(value);
    }
    if (key === "attestationNumber") {
      setAttestationNumber(value);
    }
    if (key === "attestationName") {
      setAttestationName(value);
    }
    if (key === "memberName") {
      setMemberName(value);
    }
    if (key === "venueName") {
      setVenueName(value);
    }
  };
  const handleSelectChange = (value, key) => {
    if (key === "status") {
      setStatus(value);
    }
    if (key === "venueLevel") {
      setVenueLevel(value);
    }
  };
  const previousPageBtn = () => {
    if (currentPage === 1) return;
    setLoading(true);
    getTableResponse(pageSize, currentPage - 1);
    setCurrentPage(currentPage - 1);
  };
  const nextPageBtn = () => {
    if (currentPage === Math.ceil(totalPages)) return;
    setLoading(true);
    getTableResponse(pageSize, currentPage + 1);
    setCurrentPage(currentPage + 1);
  };
  const toDetail = (record) => {
    const queryParams = new URLSearchParams({
      attestationModel: record.attestationModel,
      attestationName: record.attestationName,
      attestationNumber: record.attestationNumber,
      attestationType: record.attestationType,
      certificationBasis: record.certificationBasis,
      closingDate: record.closingDate,
      createAt: record.createAt,
      createBy: record.createBy,
      displayStatus: record.displayStatus,
      id: record.id,
      imageAddress: record.imageAddress,
      issueDate: record.issueDate,
      memberName: record.memberName,
      productionAddress: record.productionAddress,
      status: record.status,
      venueName: record.venueName,
      venueLevel: record.venueLevel,
      venueAddress: record.venueAddress,
    });
    // 跳转到目标路由，传递查询参数
    navigate(`/detail?${queryParams.toString()}`);
  };
  const searchBtn = async () => {
    await setTableData([]);
    setLoading(true);
    await getTableResponse(pageSize, 1);
  };
  const handlePageSizeChange = async (current, size) => {
    await setPageSize(size); // 更新每页显示条数
    setCurrentPage(current); // 重置为第一页，防止出现分页越界
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getTableResponse = async (pageSize, currentPage) => {
    if (loading) return;
    const statusMap = {
      "-1": "全部",
      0: "有效",
      1: "暂停",
      2: "撤销",
      3: "注销",
    };
    const venueLevelMap = {
      1: "一星级篮球场地",
      2: "二星级篮球场地",
      3: "三星级篮球场地",
      4: "三星级PRO篮球场地",
    };
    try {
      let startTime = "";
      let endTime = "";
      if (dateRange === null) {
        startTime = "";
        endTime = "";
      } else if (
        dateRange.length === 2 &&
        dateRange[0] !== null &&
        dateRange[1] !== null
      ) {
        startTime = dateRange[0].format("YYYY-MM-DD HH:mm:ss");
        endTime = dateRange[1].format("YYYY-MM-DD HH:mm:ss");
      } else {
        startTime = "";
        endTime = "";
      }

      console.log("startTime:", startTime, "endTime:", endTime);
      const response = await PostMemberAttestation({
        pageIndex: currentPage,
        pageSize: pageSize,
        attestationNumber: attestationNumber,
        attestationName: attestationName,
        attestationModel: attestationModel,
        certificationBasis: certificationBasis,
        status: Number(status),
        memberName: memberName,
        attestationType: Number(attestationType),
        displayStatus: 1,
        startTime,
        endTime,
        venueName: Number(attestationType) == 4 ? venueName : "",
        venueLevel: Number(attestationType) == 4 ? venueLevel : null,
      });

      var list = response.data.data.map((item) => {
        return {
          ...item,
          status: statusMap[item.status] || "未知状态",
          venueLevel: venueLevelMap[item.venueLevel] || "",
          issueDate: item.issueDate ? item.issueDate.substring(0, 10) : "---",
        };
      });

      setTableData(list);
      setTotalPages(response.data.totalPages);
      setTotal(response.data.totalCount);
    } catch (error) {
      console.error("请求数据失败:", error);
    } finally {
      setLoading(false);
    }
  };
  const getResponseData = useCallback(
    async (page) => {
      if (loading) return;
      setLoading(true);
      const statusMap = {
        0: "有效",
        1: "暂停",
        2: "撤销",
        3: "注销",
      };
      const venueLevelMap = {
        1: "一星级篮球场地",
        2: "二星级篮球场地",
        3: "三星级篮球场地",
        4: "三星级PRO篮球场地",
      };
      try {
        var startDate = queryParams.get("startDate");
        var endDate = queryParams.get("endDate");
        var status = queryParams.get("status");
        var memberName = queryParams.get("memberName");
        var attestationType = queryParams.get("attestationType");
        var attestationName = queryParams.get("attestationName");
        var attestationModel = queryParams.get("attestationModel");
        var attestationNumber = queryParams.get("attestationNumber");
        var certificationBasis = queryParams.get("certificationBasis");
        var venueLevel = queryParams.get("venueLevel");
        const response = await PostMemberAttestation({
          pageIndex: page,
          pageSize: 10,
          attestationNumber: attestationNumber,
          attestationName: attestationName,
          attestationModel: attestationModel,
          certificationBasis: certificationBasis,
          status: Number(status),
          memberName: memberName,
          attestationType: Number(attestationType),
          displayStatus: 1,
          startTime: startDate,
          endTime: endDate,
          venueLevel: venueLevel,
        });

        var list = response.data.data.map((item) => {
          return {
            ...item,
            status: statusMap[item.status] || "未知状态",
            venueLevel: venueLevelMap[item.venueLevel] || "",
            issueDate: item.issueDate ? item.issueDate.substring(0, 10) : "---",
          };
        });

        setTableData(list);
        setTotal(response.data.totalCount);
        setTotalPages(response.data.totalPages);
      } catch (error) {
        console.error("请求数据失败:", error);
      } finally {
        setLoading(false);
      }
    },
    [loading],
  );
  const openRenders = (record) => {
    var bloos = record.imageAddress.endsWith(".pdf");
    setIsPDF(bloos);
    setImageAddress(record.imageAddress);
    setIsOnShow(true);
  };
  const closeImgs = () => {
    setIsOnShow(false);
  };
  useEffect(() => {
    const startStr = queryParams.get("startDate");
    const endStr = queryParams.get("endDate");

    // 1. 转换
    const startDate = dayjs(startStr);
    const endDate = dayjs(endStr);

    // 2. 验证
    // 只有当两个日期都有效时，才赋值数组
    if (startDate.isValid() && endDate.isValid()) {
      setDateRange([startDate, endDate]);
    } else {
      // 如果无效（比如参数缺失或格式错误），重置为 null，让组件显示为空
      setDateRange(null);
    }
    setStatus(queryParams.get("status"));
    setMemberName(queryParams.get("memberName"));
    setAttestationType(queryParams.get("attestationType"));
    setAttestationName(queryParams.get("attestationName"));
    setAttestationModel(queryParams.get("attestationModel"));
    setAttestationNumber(queryParams.get("attestationNumber"));
    setCertificationBasis(queryParams.get("certificationBasis"));
    const level = Number(queryParams.get("venueLevel"))
      ? Number(queryParams.get("venueLevel"))
      : "";
    setVenueLevel(level);
    getResponseData(1);
    var type = queryParams.get("attestationType");
    if (type == 1) {
      setColumns([
        {
          title: (
            <span
              style={{ color: "#666666" }}
              className={styles.columnsfontsize}
            >
              序号
            </span>
          ),
          dataIndex: "key",
          render: (text, record, index) => (
            <span className={styles.columnsfontsize}>{index + 1}</span>
          ),
          flex: 1,
        },
        {
          title: (
            <span
              style={{ color: "#666666" }}
              className={styles.columnsfontsize}
            >
              获证组织名称
            </span>
          ),
          dataIndex: "memberName",
          render: (text) => (
            <span className={styles.columnsfontsize}>{text}</span>
          ),
          width: 200,
        },
        {
          title: (
            <span
              style={{ color: "#666666" }}
              className={styles.columnsfontsize}
            >
              证书编号
            </span>
          ),
          dataIndex: "attestationNumber",
          render: (text) => (
            <span className={styles.columnsfontsize}>{text}</span>
          ),
          width: 150,
        },
        {
          title: (
            <span
              style={{ color: "#666666" }}
              className={styles.columnsfontsize}
            >
              产品名称
            </span>
          ),
          dataIndex: "attestationName",
          render: (text) => (
            <span className={styles.columnsfontsize}>{text}</span>
          ),
          width: 160,
        },
        {
          title: (
            <span
              style={{ color: "#666666" }}
              className={styles.columnsfontsize}
            >
              产品型号
            </span>
          ),
          dataIndex: "attestationModel",
          render: (text) => (
            <span className={styles.columnsfontsize}>{text}</span>
          ),
          width: 100,
        },
        {
          title: (
            <span
              style={{ color: "#666666" }}
              className={styles.columnsfontsize}
            >
              认证依据
            </span>
          ),
          dataIndex: "certificationBasis",
          render: (text) => (
            <span className={styles.columnsfontsize}>{text}</span>
          ),
          width: 150,
        },
        {
          title: (
            <span
              style={{ color: "#666666" }}
              className={styles.columnsfontsize}
            >
              生产地址
            </span>
          ),
          dataIndex: "productionAddress",
          render: (text) => (
            <span className={styles.columnsfontsize}>{text}</span>
          ),
          width: 500,
        },
        {
          title: (
            <span
              style={{ color: "#666666" }}
              className={styles.columnsfontsize}
            >
              发证日期
            </span>
          ),
          dataIndex: "issueDate",
          render: (text) => (
            <span className={styles.columnsfontsize}>{text}</span>
          ),
          flex: 1,
        },
        {
          title: (
            <span
              style={{ color: "#666666" }}
              className={styles.columnsfontsize}
            >
              状态
            </span>
          ),
          dataIndex: "status",
          render: (text) => (
            <span className={styles.columnsfontsize}>{text}</span>
          ),
          flex: 1,
        },
        {
          title: (
            <span
              style={{ color: "#666666", paddingRight: "20px" }}
              className={styles.columnsfontsize}
            >
              证书详情
            </span>
          ),
          dataIndex: "certificateDetails",
          flex: 1,
          align: "right",
          render: (text, record) => (
            <Button
              type="link"
              onClick={() => openRenders(record)}
              className={styles.columnsfontBtn}
              style={{ background: "#E78110", color: "#fff", fontSize: "14px" }}
            >
              点击查看
            </Button>
          ),
        },
      ]);
    } else if (type == 4) {
      setColumns([
        {
          title: (
            <span
              style={{ color: "#666666" }}
              className={styles.columnsfontsize}
            >
              序号
            </span>
          ),
          dataIndex: "key",
          render: (text, record, index) => (
            <span className={styles.columnsfontsize}>{index + 1}</span>
          ),
          width: 60,
          flex: 1,
        },
        {
          title: (
            <span
              style={{ color: "#666666" }}
              className={styles.columnsfontsize}
            >
              场地名称
            </span>
          ),
          dataIndex: "venueName",
          render: (text) => (
            <span className={styles.columnsfontsize}>{text}</span>
          ),
          flex: 1,
        },
        {
          title: (
            <span
              style={{ color: "#666666" }}
              className={styles.columnsfontsize}
            >
              证书编号
            </span>
          ),
          dataIndex: "attestationNumber",
          render: (text) => (
            <span className={styles.columnsfontsize}>{text}</span>
          ),
          flex: 1,
        },
        {
          title: (
            <span
              style={{ color: "#666666" }}
              className={styles.columnsfontsize}
            >
              场地等级
            </span>
          ),
          dataIndex: "venueLevel",
          render: (text) => (
            <span className={styles.columnsfontsize}>{text}</span>
          ),
          flex: 1,
        },
        {
          title: (
            <span
              style={{ color: "#666666" }}
              className={styles.columnsfontsize}
            >
              场地地址
            </span>
          ),
          dataIndex: "venueAddress",
          render: (text) => (
            <span className={styles.columnsfontsize}>{text}</span>
          ),
          flex: 1,
        },
        {
          title: (
            <span
              style={{ color: "#666666" }}
              className={styles.columnsfontsize}
            >
              发证日期
            </span>
          ),
          dataIndex: "issueDate",
          render: (text) => (
            <span className={styles.columnsfontsize}>{text}</span>
          ),
          flex: 1,
        },
        {
          title: (
            <span
              style={{ color: "#666666" }}
              className={styles.columnsfontsize}
            >
              状态
            </span>
          ),
          dataIndex: "status",
          render: (text) => (
            <span className={styles.columnsfontsize}>{text}</span>
          ),
          flex: 1,
        },
        {
          title: (
            <span
              style={{ color: "#666666", paddingRight: "20px" }}
              className={styles.columnsfontsize}
            >
              证书详情
            </span>
          ),
          dataIndex: "certificateDetails",
          flex: 1,
          align: "right",
          render: (text, record) => (
            <Button
              type="link"
              onClick={() => openRenders(record)}
              className={styles.columnsfontBtn}
              style={{ background: "#E78110", color: "#fff", fontSize: "14px" }}
            >
              点击查看
            </Button>
          ),
        },
      ]);
    } else {
      setColumns([
        {
          title: (
            <span
              style={{ color: "#666666" }}
              className={styles.columnsfontsize}
            >
              序号
            </span>
          ),
          dataIndex: "key",
          render: (text, record, index) => (
            <span className={styles.columnsfontsize}>{index + 1}</span>
          ),
          width: 60,
          flex: 1,
        },
        {
          title: (
            <span
              style={{ color: "#666666" }}
              className={styles.columnsfontsize}
            >
              证书编号
            </span>
          ),
          dataIndex: "attestationNumber",
          render: (text) => (
            <span className={styles.columnsfontsize}>{text}</span>
          ),
          flex: 1,
        },
        {
          title: (
            <span
              style={{ color: "#666666" }}
              className={styles.columnsfontsize}
            >
              认证依据
            </span>
          ),
          dataIndex: "certificationBasis",
          render: (text) => (
            <span className={styles.columnsfontsize}>{text}</span>
          ),
          flex: 1,
        },
        {
          title: (
            <span
              style={{ color: "#666666" }}
              className={styles.columnsfontsize}
            >
              发证日期
            </span>
          ),
          dataIndex: "issueDate",
          render: (text) => (
            <span className={styles.columnsfontsize}>{text}</span>
          ),
          flex: 1,
        },
        {
          title: (
            <span
              style={{ color: "#666666" }}
              className={styles.columnsfontsize}
            >
              状态
            </span>
          ),
          dataIndex: "status",
          render: (text) => (
            <span className={styles.columnsfontsize}>{text}</span>
          ),
          flex: 1,
        },
        {
          title: (
            <span
              style={{ color: "#666666", paddingRight: "20px" }}
              className={styles.columnsfontsize}
            >
              证书详情
            </span>
          ),
          dataIndex: "certificateDetails",
          flex: 1,
          align: "right",
          render: (text, record) => (
            <Button
              type="link"
              onClick={() => openRenders(record)}
              className={styles.columnsfontBtn}
              style={{ background: "#E78110", color: "#fff", fontSize: "14px" }}
            >
              点击查看
            </Button>
          ),
        },
      ]);
    }
    setTypePage(2);
    const media = window.matchMedia("(max-width: 768px)");
    const handler = (e) => setIsMobile(e.matches);
    setIsMobile(media.matches);
    media.addEventListener("change", handler);
    return () => media.removeEventListener("change", handler);
  }, [attestationType]); // 依赖 filterData 和 getResponseData
  useEffect(() => {
    if (typePage == 2) {
      getTableResponse(pageSize, currentPage);
    }
  }, [currentPage, pageSize]);

  const rowClass = (record, index) =>
    index % 2 === 0 ? styles.evenRow : styles.oddRow;

  if (isMobile) {
    return (
      <ConfigProvider locale={zhCN} className={styles.ComponentOne}>
        <Spin spinning={loading} size="large" tip="加载中...">
          {!loading && tableData && tableData.length > 0 && (
            <div className={styles.mobiles}>
              <div className={styles.mobileList}>
                <div className={styles.yangshi}>
                  {tableData.map((item) => (
                    <div
                      key={item.id}
                      onClick={() => toDetail(item)}
                      className={styles.listItem}
                    >
                      <div className={styles.listItemContent}>
                        <div className={styles.listItemTitle}>
                          {attestationType == 1
                            ? item.attestationName
                            : item.certificationBasis}
                        </div>
                        <div className={styles.listItemDescription}>
                          {item.attestationNumber}
                        </div>
                      </div>
                      <img
                        className={styles.logotopImgs}
                        src={iconBack}
                        alt="Logo"
                      />
                    </div>
                  ))}
                </div>
              </div>

              {total > 10 && (
                <div className={styles.pagesBtns}>
                  <div
                    onClick={previousPageBtn}
                    className={
                      currentPage == 1
                        ? styles.previousPageNo
                        : styles.previousPage
                    }
                  >
                    上一页
                  </div>
                  <div
                    onClick={nextPageBtn}
                    className={
                      currentPage == totalPages
                        ? styles.previousPageNo
                        : styles.previousPage
                    }
                  >
                    下一页
                  </div>
                </div>
              )}
            </div>
          )}
          {!loading && tableData && tableData.length === 0 && (
            <Empty description="暂无数据" style={{ marginTop: "50px" }} />
          )}
        </Spin>
      </ConfigProvider>
    );
  } else {
    // 桌面端完整 UI
    return (
      <ConfigProvider locale={zhCN}>
        {/* 查询导航 */}
        <div className={styles.contentsList}>
          <Spin spinning={loading} size="large" tip="加载中...">
            <Card bordered={false} style={{ width: "100%", marginTop: "30px" }}>
              <div className={styles.seachScreen}>
                {/* 证书编号 */}
                {renderInput(
                  "证书编号:",
                  "请输入证书编号",
                  attestationNumber,
                  handleInputChange,
                  "attestationNumber",
                )}

                {attestationType == 1 && (
                  <>
                    {/*产品型号*/}
                    {renderInput(
                      "产品型号:",
                      "请输入产品型号",
                      attestationModel,
                      handleInputChange,
                      "attestationModel",
                    )}
                    {/* 产品名称 */}
                    {renderInput(
                      "产品名称:",
                      "请输入产品名称",
                      attestationName,
                      handleInputChange,
                      "attestationName",
                    )}
                    {/* 认证依据 */}
                    {renderInput(
                      "认证依据:",
                      "请输入认证依据",
                      certificationBasis,
                      handleInputChange,
                      "certificationBasis",
                    )}
                    {/* 获证组织 */}
                    {renderInput(
                      "获证组织名称:",
                      "请输入获证组织名称",
                      memberName,
                      handleInputChange,
                      "memberName",
                    )}
                  </>
                )}
                {attestationType == 4 && (
                  <>
                    {renderInput(
                      "场地名称:",
                      "请输入场地名称",
                      venueName,
                      handleInputChange,
                      "venueName",
                    )}
                    {renderSelect(
                      "场地等级:",
                      venueLevel,
                      handleSelectChange,
                      "venueLevel",
                      venueLevelList,
                    )}
                  </>
                )}
                {/* 证书状态 */}
                {renderSelect(
                  "证书状态:",
                  status,
                  handleSelectChange,
                  "status",
                  statusList,
                )}

                {/* 发证日期 */}
                <div className={styles.item}>
                  <div className={styles.seachScreenName}>发证日期:</div>
                  <RangePicker
                    className={styles.RangePickerName}
                    placeholder={["开始时间", "结束时间"]}
                    size="middle"
                    value={dateRange}
                    onChange={handleDateRangeChange}
                    format="YYYY-MM-DD" // 1. 显式指定格式，确保只显示日期
                    allowClear={true} // 2. 允许用户点击叉号清空
                  />
                </div>

                <Button
                  style={{
                    background: "#15356A",
                  }}
                  className={styles.seachBtn}
                  type="primary"
                  size="Large"
                  onClick={searchBtn}
                  icon={<SearchOutlined />}
                >
                  查询
                </Button>
              </div>
            </Card>

            {!loading && tableData && tableData.length > 0 && (
              <Card
                bordered={false}
                style={{ width: "100%", marginTop: "15px" }}
              >
                <div className={styles.titleName}>
                  {" "}
                  {attestationType == 1
                    ? "产品认证证书查询结果"
                    : attestationType == 2
                      ? "服务认证证书查询"
                      : attestationType == 3
                        ? "评估评价证书查询"
                        : "FIBA场地认证证书查询"}
                </div>

                {/* scroll={{ x: 'max-content' }} */}
                <Table
                  columns={columns}
                  dataSource={tableData}
                  pagination={false}
                  rowClassName={rowClass}
                />
                <div className={styles.flootClass}>
                  <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={total}
                    onChange={handlePageChange}
                    onShowSizeChange={handlePageSizeChange} // 监听每页条数变化
                    showSizeChanger
                  />
                  <div style={{ paddingLeft: "15px", marginTop: "15px" }}>
                    共{totalPages}页
                  </div>
                  <div style={{ paddingLeft: "15px", marginTop: "15px" }}>
                    共{total}条记录
                  </div>
                </div>
              </Card>
            )}
            {isOnShow && (
              <div onClick={closeImgs} className={styles.etCety}>
                <div className={styles.bottomBtns}>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {isPDF ? (
                      <div
                        style={{
                          position: "relative",
                          width: "700px",
                          height: "100vh",
                          backgroundColor: "#fff",
                          padding: "20px",
                        }}
                      >
                        <iframe
                          src={`${imageAddress}#toolbar=0&navpanes=0&scrollbar=0`}
                          title="PDF Preview"
                          style={{
                            width: "100%",
                            height: "100%",
                            border: "none",
                            // backgroundColor: '#fff',
                            overflow: "auto", // 确保 PDF 内容可以滚动
                          }}
                        ></iframe>
                      </div>
                    ) : (
                      <div className={styles.containerStyle}>
                        <img
                          src={imageAddress}
                          alt=""
                          className={styles.imageStyle}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {!loading && tableData && tableData.length === 0 && (
              <Empty description="暂无数据" style={{ marginTop: "50px" }} />
            )}
          </Spin>
        </div>
      </ConfigProvider>
    );
  }
};

export default CertificationList;
